import { useRef } from 'react';
import { Label, ToggleButton, ToggleButtonGroup } from 'react-aria-components';

const AGE_OPTIONS = [
  ...Array.from({length: 20}, (_, age) => ({ value: `age_${age}`, text: `${age}` })),
  { value: 'seniors', text: 'Seniors' }
];
const AGE_GROUPS = [
  { label: 'Children', options: AGE_OPTIONS.slice(0, 18) },
  { label: 'Adults', options: AGE_OPTIONS.slice(18) }
];

export default function TAB_AGES({ providerData, updateAges }) {
  const ages = providerData?.extractions?.ages || {};
  const agesRef = useRef(ages);
  agesRef.current = ages;
  const dragState = useRef(null);
  const ageValues = Object.fromEntries(
    AGE_OPTIONS.map(({value}) => [value, ages[value] === 'YES' || ages[value] === true])
  );

  const updateAgeValues = (options, selectedValues) => {
    const nextAges = {
      ...agesRef.current,
      ...Object.fromEntries(
        options.map(({value}) => [value, selectedValues.has(value) ? 'YES' : 'NO'])
      )
    };
    agesRef.current = nextAges;
    updateAges(nextAges);
  };

  const getSelectedValues = (options) => new Set(
    options.filter((option) => (
      agesRef.current[option.value] === 'YES' || agesRef.current[option.value] === true
    )).map((option) => option.value)
  );

  return (
    <div className='tab-ages'>
      <div className='text--md medium'>Ages</div>
      <div className='subheading'>Age groups supported by the provider.</div>
      <div className='tab-ages__groups'>
        {AGE_GROUPS.map(({label, options}) => (
          <div
            className='tab-ages__group'
            key={label}
          >
            <Label>{label}</Label>
            <ToggleButtonGroup
              aria-label={`${label} age groups`}
              selectionMode='multiple'
              selectedKeys={new Set(
                options.filter(({value}) => ageValues[value]).map(({value}) => value)
              )}
            >
              {options.map(({value, text}) => (
                <ToggleButton
                  id={value}
                  key={value}
                  onPointerDown={(event) => {
                    if (event.pointerType !== 'mouse') return;
                    dragState.current = {
                      target: !ageValues[value],
                      moved: false
                    };
                  }}
                  onPointerEnter={(event) => {
                    if (event.pointerType !== 'mouse' || !dragState.current) return;
                    dragState.current.moved = true;
                    const selectedValues = getSelectedValues(options);
                    if (dragState.current.target) selectedValues.add(value);
                    else selectedValues.delete(value);
                    updateAgeValues(options, selectedValues);
                  }}
                  onClick={() => {
                    if (dragState.current?.moved) {
                      dragState.current = null;
                      return;
                    }
                    const selectedValues = getSelectedValues(options);
                    if (selectedValues.has(value)) selectedValues.delete(value);
                    else selectedValues.add(value);
                    updateAgeValues(options, selectedValues);
                    dragState.current = null;
                  }}
                >
                  {text}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>
        ))}
      </div>
    </div>
  );
}